import { render } from "./DashboardGiftCardSales.vue?vue&type=template&id=31e37f7c&scoped=true"
import script from "./DashboardGiftCardSales.vue?vue&type=script&lang=js"
export * from "./DashboardGiftCardSales.vue?vue&type=script&lang=js"

import "./DashboardGiftCardSales.vue?vue&type=style&index=0&id=31e37f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e37f7c"]])

export default __exports__